module.exports = __webpack_public_path__ + "static/img/DSC_1577_01.422b6018.png";